<div style="text-align:center;">
  <p>LANDING PAGE</p>
  <button class="btn bg-primary text-light" routerLink="/Login">Acceder</button>
</div>

